import { Link } from "react-router-dom";
import Icon, { FacebookIcon } from "./Icon";
import { NAV } from "./Header";
import { COMPANY, telHref } from "../content/site";
import s from "./Footer.module.css";

export default function Footer() {
  return (
    <footer className={s.footer}>
      <div className={`container ${s.grid}`}>
        <div className={s.brand}>
          <Link to="/" className={s.logo}>
            <img src="/favicon.png" alt="" width="32" height="32" />
            <span>VoltNaPřání</span>
          </Link>
          <p>Individuální dovoz elektromobilů z EU a skladové vozy s ověřeným stavem baterie.</p>
          <a href={COMPANY.facebook} target="_blank" rel="noopener noreferrer" className={s.social}>
            <FacebookIcon size={18} /> Facebook
          </a>
        </div>

        <nav aria-label="Patička">
          <h2 className="eyebrow">Stránky</h2>
          <ul className={`${s.list} ${s.pages}`}>
            <li><Link to="/">Úvod</Link></li>
            {NAV.map((n) => <li key={n.to}><Link to={n.to}>{n.label}</Link></li>)}
            <li><Link to="/#faq">Časté dotazy</Link></li>
          </ul>
        </nav>

        <div>
          <h2 className="eyebrow">Kontakt</h2>
          <ul className={s.list}>
            <li><a href={telHref(COMPANY.phone)} className="num"><Icon name="phone" size={16} />{COMPANY.phone}</a></li>
            <li><a href={`mailto:${COMPANY.email}`}><Icon name="mail" size={16} />{COMPANY.email}</a></li>
            <li className={s.plain}><Icon name="clock" size={16} />{COMPANY.hours}</li>
          </ul>
        </div>

        <div>
          <h2 className="eyebrow">Provozovatel</h2>
          <address className={s.address}>
            {COMPANY.owner}<br />
            {COMPANY.street}<br />
            {COMPANY.city}<br />
            IČO <span className="num">{COMPANY.ico}</span>
          </address>
        </div>
      </div>

      <div className={`container ${s.bottom}`}>
        <p>© {new Date().getFullYear()} VoltNaPřání. Všechna práva vyhrazena.</p>
      </div>
    </footer>
  );
}
